import React from 'react';

import useSubscriptionCard from './hooks/useSubscriptionCard';

import SubscriptionRedemption from './components/SubscriptionRedemption';
import PendingSubscription from './components/PendingSubscription';
import PausedSubscription from './components/PausedSubscription';
import ExpiresSubscription from './components/ExpiresSubscription';
import ExpiredSubscription from './components/ExpiredSubscription';
import DefaultSubscription from './components/DefaultSubscription';

import { ISubscriptionCard } from './types';

const SubscriptionCard = ({ onCancelSubscription, subscription }: ISubscriptionCard) => {
  const {
    feeData,
    isExpiredSubscription,
    isExpiresSubscription,
    isSubscriptionRedemption,
    isPendingSubscription,
    isSubscriptionPaused,
    isFreeMonthActive,
    isMainSubscription,
    handleCancelSubscription,
    state,
    upcomingProduct,
    tabIcon,
    heading,
    subscriptionPeriod,
    subscriptionType,
    price,
    expirationDate,
    isUpgrade,
    paymentMethod,
    isOneTimeProduct = false,
    isPromoCodeUsed = false,
  } = useSubscriptionCard({ subscription, onCancelSubscription });

  const commonProps = {
    feeData,
    tabIcon,
    heading,
    isMainSubscription,
    subscriptionPeriod,
    subscriptionType,
    price,
    isUpgrade,
    isOneTimeProduct,
    expirationDate,
    isPromoCodeUsed,
  };

  if (isExpiredSubscription) {
    return <ExpiredSubscription {...commonProps} />;
  }

  if (isExpiresSubscription) {
    const isDiscountOfferAvailable = !subscription.discounts.discount;

    return (
      <ExpiresSubscription
        {...commonProps}
        paymentMethod={paymentMethod}
        isDiscountOfferAvailable={isDiscountOfferAvailable}
      />
    );
  }

  if (isSubscriptionPaused) {
    return (
      <PausedSubscription
        {...commonProps}
        isMainSubscription={isMainSubscription}
        onCancelSubscription={handleCancelSubscription}
      />
    );
  }

  if (isSubscriptionRedemption) {
    return <SubscriptionRedemption {...commonProps} onCancelSubscription={handleCancelSubscription} />;
  }

  if (isPendingSubscription) {
    return <PendingSubscription {...commonProps} state={state} upcomingProduct={upcomingProduct} />;
  }

  return (
    <DefaultSubscription
      {...commonProps}
      state={state}
      upcomingProduct={upcomingProduct}
      onCancelSubscription={handleCancelSubscription}
      withFreeMonth={isFreeMonthActive}
    />
  );
};

export default SubscriptionCard;
